import type { FC } from "react";
import { match } from "ts-pattern";

import type { PageMetadata } from "@moment/api-collab/api-types";
import { DatabaseIcon, DocumentIcon, SendIcon } from "@moment/icons";
import { useHttpRequestPage } from "@moment/state";

export interface PageLinkPageIconProps {
	documentId: string;
	page: PageMetadata;
	className?: string;
}

export const PageLinkPageIcon: FC<PageLinkPageIconProps> = ({ documentId, page, className }) => {
	const { httpRequestPage } = useHttpRequestPage(documentId, page.id);

	if (page.type !== "request") {
		return <DocumentIcon className={className} />;
	}

	const requestType = httpRequestPage?.request?.request?.type;

	return match(requestType)
		.with("http", () => <SendIcon className={className} />)
		.with("postgres", () => <DatabaseIcon className={className} />)
		.with("sqlite", () => <DatabaseIcon className={className} />)
		.otherwise(() => <DocumentIcon className={className} />);
};
